<template>
  <el-dialog title='添加结算' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='700px'>
    <el-form :model='form' label-width='130px' label-position='right' :rules='rules'
             ref='ruleForm' class='settlement-form'>
      <el-form-item label='结算类型：' prop='type' style='margin-top: 15px'>
        <el-select v-model='form.type' filterable size='mini' placeholder='请选择结算方式'
                   value-key='settlementTypeId'>
          <el-option v-for='item in settlementTypeArr' :label='item.label'
                     :value='item.value' :key='item.value'></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label='结算方式：' prop='settType' style='margin-top: 15px'>
        <el-checkbox-group v-model="form.settType" @change="getType">
          <el-checkbox :label="0" :disabled="disabled1" @change="selectType1">合同价</el-checkbox>
          <el-checkbox :label="1" :disabled="disabled2" @change="selectType">预结算价</el-checkbox>
          <el-checkbox :label="2" v-if="importShow">预估价</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label='合同：' prop='contract'>
        <el-select v-model="form.contract" filterable style="width: 100%" size="small"
                   placeholder="请选择合同" value-key="id">
          <el-option
            v-for="item in contractOption" :key="item.id" :label="item.contractName"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if='!(form.type === "5" || form.type === "6" || form.type === "")'
                    label='作业类型：' prop='transportType'>
        <el-radio-group v-model='form.transportType'>
          <el-radio v-for='item in settlementType[form.type - 2]' :label='item.value'
                    :key='item.value'>
            {{ item.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if='form.type === "4"' label='港口：' prop='portId'>
        <el-select v-model='form.portId' filterable size='mini' placeholder='请选择港口'
                   value-key='portId'>
          <el-option v-for='item in portData' :key='item.id' :label='item.supplier_name'
                     :value='item.id' />
        </el-select>
      </el-form-item>
      <el-form-item v-if='form.type === "4"' label='作业日期：' prop='workDate'>
        <el-date-picker
          v-model='form.workDate'
          size='mini'
          type='date'
          value-format='yyyy-MM-dd'
          placeholder='选择日期'>
        </el-date-picker>
      </el-form-item>
      <el-form-item label='税率：' prop='taxRate'>
        <el-input v-model='form.taxRate' type='number' size='mini'></el-input>
      </el-form-item>
      <el-form-item label='含税单价：' prop='taxPreparePrice'>
        <el-input v-model='form.taxPreparePrice' type='number' size='mini'></el-input>
        <div class='settlement-tips'>*注意：此单价为每台车价格</div>
      </el-form-item>
      <el-form-item>
        <div class='flex-center-center mt10'>
          <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'> 添加
          </el-button>
          <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { addSpecialGenerateSettlement, addSpecialSettlement, contractPageList } from '@/service/financial';
import { supplierPublicSelectPort } from '@/service/vehiclelog';

  export default {
    name: 'index',
    data() {
      return {
        isImport: null,
        dialogVisible: false,
        defaultForm: {},
        form: {
          carCvInfoList: [],
          settType: [],
          type: '',
          contract: '',
          transportType: '',
          taxRate: '',
          taxPreparePrice: '',
        },
        importShow: false,
        disabled1: false,
        disabled2: false,
        typeName: [],
        type: [],
        formData: [],
        contractOption: [],
        typeList: [
          {
            type: 0,
            typeName: '合同价'
          },
          {
            type: 1,
            typeName: '预结算价'
          },
          {
            type: 2,
            typeName: '预估价'
          }
        ],
        rules: {
          portId: [
            {
              required: true,
              message: '请选择港口',
              trigger: 'blur',
            },
          ],
          workDate: [
            {
              required: true,
              message: '请选择作业日期',
              trigger: 'blur',
            },
          ],
          type: [
            {
              required: true,
              message: '请选择结算方式',
              trigger: 'blur',
            },
          ],
          contract: [
            {
              required: true,
              message: '请选择合同',
              trigger: 'blur',
            },
          ],
          settType: [
            {
              required: true,
              message: '请选择结算方式',
              trigger: 'blur',
            },
          ],
          transportType: [
            {
              required: true,
              message: '请选择结算类型',
              trigger: 'blur',
            },
          ],
          taxRate: [
            {
              required: true,
              message: '请输入税率',
              trigger: 'blur',
            },
          ],
          taxPreparePrice: [
            {
              required: true,
              message: '请输入含税单价',
              trigger: 'blur',
            },
          ],
          unloadTaxRate: [
            {
              required: true,
              message: '请输入卸车税率',
              trigger: 'blur',
            },
          ],
          unloadPrice: [
            {
              required: true,
              message: '请输入卸车含税单价',
              trigger: 'blur',
            },
          ],
        },
        submitLoading: false,
        settlementTypeArr: [
          {
            label: '供应商-托运费',
            value: '2',
          },
          {
            label: '供应商-操作费',
            value: '3',
          },
          // {
          //   label: '供应商-燃油费',
          //   value: '4',
          // },
          // {
          //   label: '供应商-堆存费',
          //   value: '5',
          // },
          // {
          //   label: '供应商-提车费',
          //   value: '6',
          // },
        ],
        settlementType: [
          [
            {
              label: '公路',
              value: 0,
            },
            {
              label: '水路',
              value: 1,
            },
          ],
          [
            {
              label: '装车费',
              value: 0,
            },
            {
              label: '卸车费',
              value: 1,
            },
            {
              label: '过驳费',
              value: 2,
            },
            {
              label: '转船',
              value: 3,
            },
          ],
          [
            {
              label: '翻仓',
              value: 1,
            },
            {
              label: '加油',
              value: 2,
            },
            {
              label: '搭电',
              value: 3,
            },
            {
              label: '加气',
              value: 4,
            },
            {
              label: '洗车',
              value: 5,
            },
          ],
        ],
        portData: [],
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      //查询合同
      async _contractPageList() {
        let obj = {
          consignorId: this.form.consignorId,
        };
        let res = await contractPageList(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.contractOption = res.data;
      },
      /**
       * 打开弹出框
       * @param selectTable 当前选中数据
       * @param id
       * @param supplierName
       * @param batchNumber
       * @param waybillNumber
       * @param frameNumber
       * @param brandId
       * @param brandName
       * @param departurePlace
       * @param arrivePlace
       * @param stringDate
       */
      dialogOpen(isImport, selectTable,id,supplierName,batchNumber,waybillNumber,
                 frameNumber,brandId,brandName,departurePlace,arrivePlace,stringDate) {
        this.isImport = isImport;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.form.carCvInfoList = selectTable;
        this.form.consignorId = id.toString()
        this.form.consignorName = supplierName.toString()
        this.form.batchNumber = batchNumber.toString()
        this.form.waybillNumber = waybillNumber.toString()
        this.form.frameNumber = frameNumber.toString()
        this.form.brandId = brandId.toString()
        this.form.brandName= brandName.toString()
        this.form.departurePlace = departurePlace.toString()
        this.form.arrivePlace = arrivePlace.toString()
        this.form.stringDate = stringDate.toString()
        this.getPortData();
        this._contractPageList(id)
        this.dialogVisible = true;
      },
      async getPortData() {
        const {
          status,
          message,
          data,
        } = await supplierPublicSelectPort();
        if (status !== 0) return this.$message.error(message);
        this.portData = data.map(item => {
          return item;
        });
      },
      dialogClose() {
        this.dialogVisible = false;
        this.form = {}
        this.disabled1 = false
        this.disabled2 = false
        this.importShow = false
        this.submitLoading = false
      },
      selectType(){
        if (this.form.settType.includes(1) || this.form.settType.includes(2)) {
          this.disabled1 = true;
          this.importShow = true
        } else {
          this.disabled1 = false;
          this.importShow = false
        }
      },
      selectType1(){
        if (this.form.settType.includes(0)) {
          this.disabled2 = true;
        }else {
          this.disabled2 = false;
        }
      },
      getType(){
        this.type = this.form.settType.reduce((acc, value) => {
          switch (value) {
            case 0:
              acc += 0;
              break;
            case 1:
              acc += 1;
              break;
            case 2:
              acc += 2;
              break;
            default:
              break;
          }
          return acc;
        }, 0);
        if (this.form.settType.includes(1) && this.form.settType.includes(2)) {
          this.type = 4;
        }
        this.typeName = this.form.settType.map(value => {
          switch(value) {
            case 0:
              return "合同价";
            case 1:
              return "预结算价";
            case 2:
              return "预估价";
            default:
              return "";
          }
        });
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.submitLoading = true;
            let {
              contract
            } = this.form
            const data = await addSpecialGenerateSettlement({
              // carCvInfoList: this.form.carCvInfoList,
              id: this.isImport == 0 ? this.form.carCvInfoList.map(item => item.id).join(',') : this.isImport == 1? this.form.carCvInfoList.map(item => item.deployId).join(',') : '',
              type: this.form.type,
              settType: this.type,
              taxRate: this.form.taxRate,
              taxPreparePrice: this.form.taxPreparePrice,
              unloadPrice: this.form.unloadPrice,
              unloadTaxRate: this.form.unloadTaxRate,
              transportType: this.form.transportType,
              portId: this.form.portId,
              workDate: this.form.workDate,
            })
            if (data.status !== 0) return this.$message.warning(data.message);
            this.formData = data.data
            const res = await addSpecialSettlement({
              id: this.formData,
              consignorId: this.form.consignorId,
              consignorName: this.form.consignorName,
              batchNumber: this.form.batchNumber,
              waybillNumber: this.form.waybillNumber,
              frameNumber: this.form.frameNumber,
              brandId: this.form.brandId,
              brandName: this.form.brandName,
              departurePlace: this.form.departurePlace,
              arrivePlace: this.form.arrivePlace,
              stringDate: this.form.stringDate,
              types: this.form.type,
              type: this.form.settType.join(','),
              typeName: this.typeName.join(','),
              contractId: contract.id,
              contractName: contract.contractName,
              taxRate: this.form.taxRate,
              taxContractPrice: this.form.taxPreparePrice,
              unloadPrice: this.form.unloadPrice,
              unloadTaxRate: this.form.unloadTaxRate,
              state: 1});
            this.submitLoading = false;
            if (res.status !== -1) return this.$message.warning(res.message);
            this.$message.success(res.message);
            this.$emit('searchBtn');
            this.dialogClose();
          }
        });
      },
    },
  };
</script>

<style lang='scss' scoped>
  .settlement-form {
    width: 80%;
    margin: 0 auto;
  }

  .settlement-tips {
    margin-top: -15px;
    position: absolute;
    right: 0;
    font-size: 12px;
    color: #F56C6C;
  }

  .el-select {
    width: 100%;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }
</style>
